import React from 'react'

const LangContext = React.createContext({
    language: "ja", //default is ja
    setLanguage: () => {}
  })

export default LangContext